import environment from "../environment";

export default {
    getEnvironment(env) {
        env(environment())
    }
}



// WEBPACK FOOTER //
// ./src/managers/configmanager.js